/* @ngInject */
function timesheetService ($http, ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    createTimesheet,
    updateTimesheet,
    getTaskEntries,
    deleteTimeEntry,
    downloadTaskReport,
    downloadBoardReport,
    downloadXLSX
  }
  return service

  /**
   * @param {number} taskId
   * @param {object} payload
   * @param {string} payload.date
   * @param {string} payload.startTime
   * @param {string} payload.endTime
   * @param {string} [payload.description]
   */
  function createTimesheet (taskId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_TASK_ID, [taskId])
    return ConnectorWebService.post(url, payload)
  }

  /**
   * @param {number} taskId
   * @param {object} payload
   * @param {string} payload.date
   * @param {string} payload.startTime
   * @param {string} payload.endTime
   * @param {string} [payload.description]
   */
  function updateTimesheet (timeEntryId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_ENTRY_ID, [timeEntryId])
    return ConnectorWebService.put(url, payload)
  }

  /**
   * @param {number} taskId
   */
  function getTaskEntries (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_TASK_ID, [taskId])
    return ConnectorWebService.get(url)
  }

  /**
   * @param {number} timesheetId
   */
  function deleteTimeEntry (timeEntryId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_ENTRY_ID, [timeEntryId])
    return ConnectorWebService.fnDelete(url)
  }

  /**
   * Exports a XLSX file with time entries of task and subtasks.
   *
   * @param {number} boardId
   * @param {number} taskId
   */
  function downloadTaskReport (boardId, taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_TASK_REPORT, [boardId, taskId])
    return $http.get(url, { responseType: 'blob' })
  }

  /**
   * Exports a XLSX file with time entries of all tasks of the board.
   *
   * @param {number} boardId
   */
  function downloadBoardReport (boardId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TIMESHEETS_BOARD_REPORT, [boardId])
    return $http.get(url, { responseType: 'blob' })
  }

  /**
   * Downloads a XLSX file.
   *
   * @param {object} response
   * @param {string} fileName
   */
  function downloadXLSX (response, fileName) {
    const urlCreator = window.URL || window.webkitURL
    const blob = response.data
    const objectUrl = urlCreator.createObjectURL(blob)
    const a = document.createElement('a')

    a.target = '_blank'
    a.href = objectUrl
    a.download = fileName

    a.click()

    a.remove()
    urlCreator.revokeObjectURL(objectUrl)
  }
}

export { timesheetService }
